import React, { useContext } from "react"
import AppContext from "../../shared/AppContext"
import { BiDownload } from "react-icons/bi"

const DownloadWhitePaper = ({ trackingLocation, path }) => {
  const { trackEvent } = useContext(AppContext)
  return (
    <a
      className={"download-white-paper-button"}
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        trackEvent("Download White Paper", {
          location: trackingLocation,
        })
      }}
    >
      <BiDownload />
      <span className="button-text">Download White Paper</span>
    </a>
  )
}

export default DownloadWhitePaper
